import Swiper, { A11y, Autoplay, EffectFade } from 'swiper';

import '../../sass/blocks/case-study.scss';

(() => {
    const $caseStudies = document.querySelectorAll('.case-study');

    if (!$caseStudies) return;

    const sliders = [];

    $caseStudies.forEach($caseStudy => {
        const $sliders = $caseStudy.querySelectorAll('.case-study__slider');

        const initCarousels = () => {
            if (!$sliders) return;

            $sliders.forEach($slider => {
                const $carouselSlides = $caseStudy.querySelectorAll('.swiper-slide');

                if ($carouselSlides.length <= 1) return;
        
                const slider = new Swiper($slider, {
                    modules: [ A11y, Autoplay, EffectFade ],
                    loop: true,
                    autoplay: {
                        delay: 3000,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    allowTouchMove: false,
                });

                sliders.push(slider);
            });
        };

        initCarousels();
    });
})();
